import CheckSvg from '@/shared/assets/images/Check.svg'
import { IJobApplication } from "@/shared/api/employment"
import { FC } from "react"
import { DropdownItem } from "@/shared/ui/dropdown-item"
import { useUpdateJobApplicationModal } from "@/features/update-job-application"
import { useAppDispatch } from '@/shared/lib/redux'
import { fetchJobApplications } from '../../model'

interface ApproveApplicationProps {
    application: IJobApplication
}

export const ApproveApplication: FC<ApproveApplicationProps> = ({ application }) => {
    const { openApproveJobApplicationModal } = useUpdateJobApplicationModal()
    const dispatch = useAppDispatch()

    const onApprove = () => {
        dispatch(fetchJobApplications())
    }

    return (
        <DropdownItem 
            onClick={() => openApproveJobApplicationModal(application, onApprove)}
            icon={CheckSvg} 
            label={"Принять"}        
        />
    )
}